var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNowBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.393 3.866 7.98 18h7.187l-1.56 10.134L24.022 14h-7.187l1.56-10.134zm-.404-2.823c.93-1.262 2.929-.431 2.69 1.118L19.166 12h5.845c1.23 0 1.937 1.4 1.207 2.39L14.011 30.957c-.93 1.262-2.929.431-2.69-1.118L12.834 20H6.99c-1.23 0-1.938-1.4-1.208-2.39z"
})));
export default SvgNowBolt;